/**
 * @generated SignedSource<<40e4360334ac1b8d937aa6aba14258c5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShippingHolidayDelivery_sku$data = {
  readonly holidayShippingEstimations?: {
    readonly displayMessage: string | null;
    readonly termsAndConditions: string | null;
    readonly validHolidayShippingDays: ReadonlyArray<{
      readonly estimatedDeliveryDay: string | null;
      readonly shipmentQuoteId: string | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "PdpSharedShippingHolidayDelivery_sku";
};
export type PdpSharedShippingHolidayDelivery_sku$key = {
  readonly " $data"?: PdpSharedShippingHolidayDelivery_sku$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShippingHolidayDelivery_sku">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    },
    {
      "kind": "RootArgument",
      "name": "timezoneOffset"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingHolidayDelivery_sku",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "timezoneOffset",
              "variableName": "timezoneOffset"
            }
          ],
          "concreteType": "HolidayShippingEstimationsType",
          "kind": "LinkedField",
          "name": "holidayShippingEstimations",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "displayMessage",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "termsAndConditions",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "ValidHolidayShippingDays",
              "kind": "LinkedField",
              "name": "validHolidayShippingDays",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "shipmentQuoteId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "estimatedDeliveryDay",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "ItemSkuType",
  "abstractKey": null
};

(node as any).hash = "28b5b0f2f872905e50b57fb5940d9ddc";

export default node;
